import Layout from "@/views/layout/library/index";

const ruleLib = [
    {
        path: "/singles",
        component: Layout,
        name: "规则",
        icon: "zonghe",
        redirect: "/singles/addEntry",
        children: [
            {
                path: "addEntry",
                component: resolve => require(["@/components/ruleLib/knowledgeBaseManage/addEntry"], resolve),
                name: "添加条目",
                icon: "zonghe",
                meta: {
                    keepAlive: false // true 表示需要使用缓存 false表示不需要被缓存
                }
            },
            {
                path: "generateRule",
                component: () => import("@/components/ruleLib/knowledgeBaseManage/generateRule"),
                name: "生成规则",
                icon: "zonghe"
            },
            {
                path: "addErcEntry",
                component: resolve => require(["@/components/ercRuleLib/knowledgeBaseManage/addEntry"], resolve),
                name: "erc添加条目",
                icon: "zonghe",
                meta: {
                    keepAlive: false // true 表示需要使用缓存 false表示不需要被缓存
                }
            },
            {
                path: "generateErcRule",
                component: () => import("@/components/ercRuleLib/knowledgeBaseManage/generateRule"),
                name: "erc生成规则",
                icon: "zonghe"
            },
        ]
    }
]

export default ruleLib;
